import { useEffect, useState } from 'react';
import { apiService } from '../services/apiService';

/**
 * Fetches system-wide setup counts once.
 * Returns { status, loading } where status has boolean flags for each entity.
 */
const useSetupStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only fetch setup status for admins
    const userStr = sessionStorage.getItem('user');
    let user = null;
    try {
      user = JSON.parse(userStr);
    } catch (e) {}

    if (!user || user.role !== 'admin') {
      setLoading(false);
      return;
    }

    let cancelled = false;
    const load = async () => {
      try {
        const [programmes, classes, teachers, modules, students] = await Promise.allSettled([
          apiService.getAll('programmes-list'),
          apiService.getAll('classes'),
          apiService.getAll('teachers'),
          apiService.getAll('modules'),
          apiService.getAll('students'),
        ]);

        const val = r => (r.status === 'fulfilled' ? r.value || [] : []);

        if (!cancelled) {
          const p = val(programmes);
          const c = val(classes);
          const t = val(teachers);
          const m = val(modules);
          const s = val(students);

          setStatus({
            hasProgrammes:       p.length > 0,
            hasClasses:          c.length > 0,
            hasTeachers:         t.length > 0,
            hasModules:          m.length > 0,
            hasStudents:         s.length > 0,
            hasAssignedTeachers: c.some(cls => cls.teacher),
            counts: {
              programmes: p.length,
              classes:    c.length,
              teachers:   t.length,
              modules:    m.length,
              students:   s.length,
            },
          });
        }
      } catch {
        if (!cancelled) setStatus(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  return { status, loading };
};

export default useSetupStatus;
